<template>
    <feedback-form ref="feedbackForm" :title="title" :description="description" :button="button" @send-form="submit"></feedback-form>
</template>

<script>
import FeedbackForm from "../../vue/FeedbackForm";
import ApiService from "../../api/api";

export default {
    name: "PlaceLandingFeedback",
    props: ['title', 'description', 'button', 'sum', 'services'],
    components: { FeedbackForm },
    methods: {
        submit: function(form) {
            if (this.sum) {
                form.sum = this.sum;
                form.services = this.services;
            }

            return new Promise((resolve, reject) => {
                this.$loading(this.$optionsLoading);

                ApiService.post('/place/send-feedback', form)
                    .then((response) => {
                        this.$refs.feedbackForm.$emit('reset-form');

                        this.$appNotify.success(this.$lang('services.success'));

                        // Если указана сумма, это значит что мы пришли со страницы срачета смоимости, поэтому
                        // редиректим на лендинг памятных мест
                        if (this.sum) {
                            setTimeout(() => {
                                window.location.href = this.$router.resolve({name: 'place'}).href;
                            }, 2000);
                        } else {
                            this.$router.go(-1);
                        }
                    })
                    .catch((error) => {
                        if(error.response.data.errors) {
                            this.$refs.feedbackForm.$emit('show-errors', error.response.data.errors);
                        } else {
                            this.$appNotify.error(this.$lang('services.error'));
                        }
                    })
                    .finally(() => {
                        this.$loading({}).close();
                    });
            });
        }
    }
}
</script>
